import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [modal, setModal] = useState({marker: {}, isVisible: false});

  const showModal = (marker) => setModal({marker, isVisible: true});

  const hideModal = (marker) => setModal({marker, isVisible: false})

  return <ModalContext.Provider value={{ modal, showModal, hideModal }}>{children}</ModalContext.Provider>;
}

export const useModal = () => useContext(ModalContext);
